import { useEffect as UseEffect, useState as UseState } from "react";
import MenuApp from '../../../components/Menu';
import TriStateSwitch from "../../../components/Switch3";
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import RefreshIcon from '@mui/icons-material/Refresh';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Grid from '@mui/material/Grid';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField'
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import informationService from '../../../services/system';
import AuthService from "../../../services/security/auth.service";
import TokenService from "../../../services/security/token.service";
import DateComponent from '../../../components/Date';
import FooterOperaciones from "../../../components/Footer";

const HomeAdmin = () => {
    const user = TokenService.getUser();
    const [collapsedStatesBox1, setCollapsedStatesBox1] = UseState(true);
    const [collapsedStatesBox2, setCollapsedStatesBox2] = UseState(true);
    const [collapsedStatesBox3, setCollapsedStatesBox3] = UseState(true);
    const [collapsedStatesBox4, setCollapsedStatesBox4] = UseState(true);
    const [collapsedStatesBox5, setCollapsedStatesBox5] = UseState(true);
    const [collapsedStatesBox6, setCollapsedStatesBox6] = UseState(true);
    const [collapsedStatesBox7, setCollapsedStatesBox7] = UseState(true);
    const [collapsedStatesBox8, setCollapsedStatesBox8] = UseState(true);
    const [filterDate, setFilterDate] = UseState(null);
    const [dataBox1, setDataBox1] = UseState([]);
    const [dataBox2, setDataBox2] = UseState([]);
    const [dataBox5, setDataBox5] = UseState([]);
    const [dataBox6, setDataBox6] = UseState([]);
    const [dataBox8, setDataBox8] = UseState([]);
    const [totalesBox8, setTotalesBox8] = UseState({});
    const [operacionesDiaNoPost, setOperacionesDiaNoPost] = UseState([]);
    const [proveedoresDiaNoPost, setProveedoresDiaNoPost] = UseState([]);
    const [operacionesDia, setOperacionesDia] = UseState([]);
    const [dataBox2Original, setDataBox2Original] = UseState([]);
    const [dataBox6Original, setDataBox6Original] = UseState([]);
    const [saldoAnteriorBox1, setSaldoAnteriorBox1] = UseState([]);
    const [saldoAnteriorBox5, setSaldoAnteriorBox5] = UseState([]);
    const [filtersValues, setFiltersValues] = UseState([]);
    const [filtersValuesBox6, setFiltersValuesBox6] = UseState([]);
    const [loadBox1, setLoadBox1] = UseState(false);
    const [loadBox2, setLoadBox2] = UseState(false);
    const [loadBox3, setLoadBox3] = UseState(false);
    const [loadBox4, setLoadBox4] = UseState(false);
    const [loadBox5, setLoadBox5] = UseState(false);
    const [loadBox6, setLoadBox6] = UseState(false);
    const [loadBox7, setLoadBox7] = UseState(false);
    const [loadBox8, setLoadBox8] = UseState(false);
    const [switchBox2, setSwitchBox2] = UseState(true);
    const [switchBox3, setSwitchBox3] = UseState(null);
    const [switchBox6, setSwitchBox6] = UseState(true);
    let fieldFilter = { isSettlementToday: true };
    let fieldFilterBox6 = { isSettlementToday: true };
    UseEffect(() => {
        document.title = `Home - wBroker`;
        let dateNow = formatDate(new Date());
        setLoadBox1(false);
        setLoadBox2(false);
        setLoadBox3(false);
        setLoadBox4(false);
        setLoadBox5(false);
        setLoadBox6(false);
        setFilterDate(dateNow);
        searchViewListBox1(dateNow);

    }, []);

    const updateList = () => {
        let dateNow = filterDate != null ? filterDate : formatDate(new Date());

        setLoadBox1(false);
        setLoadBox2(false);
        setLoadBox3(false);
        setLoadBox4(false);
        setLoadBox5(false);
        setLoadBox6(false);
        setFilterDate(dateNow);
        searchViewListBox1(dateNow);
    }

    const handleToggleCollapseBox1 = () => {

        if (collapsedStatesBox1)
            setCollapsedStatesBox1(false)
        else
            setCollapsedStatesBox1(true);
    };

    const handleToggleCollapseBox2 = () => {

        if (collapsedStatesBox2)
            setCollapsedStatesBox2(false)
        else
            setCollapsedStatesBox2(true);
    };

    const handleToggleCollapseBox3 = () => {

        if (collapsedStatesBox3)
            setCollapsedStatesBox3(false)
        else
            setCollapsedStatesBox3(true);
    };

    const handleToggleCollapseBox4 = () => {

        if (collapsedStatesBox4)
            setCollapsedStatesBox4(false)
        else
            setCollapsedStatesBox4(true);
    };

    const handleToggleCollapseBox5 = () => {

        if (collapsedStatesBox5)
            setCollapsedStatesBox5(false)
        else
            setCollapsedStatesBox5(true);
    };

    const handleToggleCollapseBox6 = () => {

        if (collapsedStatesBox6)
            setCollapsedStatesBox6(false)
        else
            setCollapsedStatesBox6(true);
    };

    const handleToggleCollapseBox7 = () => {

        if (collapsedStatesBox7)
            setCollapsedStatesBox7(false)
        else
            setCollapsedStatesBox7(true);
    };

    const handleToggleCollapseBox8 = () => {

        if (collapsedStatesBox8)
            setCollapsedStatesBox8(false)
        else
            setCollapsedStatesBox8(true);
    };

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    const handleFieldChange = (e) => {
        let value = e.target.value;
        setFilterDate(value);
        searchViewListBox1(value);
    }

    const filterByTradeAccountIdManagerId = () => {
        const user = AuthService.getCurrentUser();
        let whereFieldParam = [];
        if (user.data.companyId) {
            whereFieldParam.push({
                idField: 'companyId',
                operator: '=',
                value: user.data.companyId
            })
        }

        if (user.data.tradeAccountId) {
            whereFieldParam.push({
                idField: 'tradeAccountId',
                operator: '=',
                value: user.data.tradeAccountId
            })
        } else {
            if (user.data.isManager === '1') {
                whereFieldParam.push({
                    idField: 'managerId',
                    operator: '=',
                    value: user.data.managerId
                })
            }
        }
        return whereFieldParam;
    }


    const searchViewListBox1 = (value) => {
        const user = AuthService.getCurrentUser();
        let date = value.split('-');
        let dueDateFlag = new Date(date[0], Number(date[1]) - 1, date[2]);
        let dueDateFlag1 = new Date(date[0], Number(date[1]) - 1, date[2]);
        let dueDate = formatDate(dueDateFlag);
        setLoadBox1(false);
        setLoadBox2(false);
        setLoadBox3(false);
        setLoadBox4(false);
        setLoadBox5(false);
        setLoadBox6(false);
        setLoadBox7(false);
        setLoadBox8(false);
        let where = filterByTradeAccountIdManagerId();

        informationService.storeProcedure('entityBalanceArAsOf', user.data.instance, dueDate, where).then((response) => {
            let results = [];
            let resultsIsSettlementToday = [];
            for (let t = 0; t < response.data.length; t++) {

                response.data[t].entityPropertyFlag = response.data[t].entityProperty;
                if (t === 0) {
                    if (response.data[t].isSettlementToday === '1') {
                        resultsIsSettlementToday.push(response.data[t]);
                    }
                    results.push(response.data[t]);
                } else {
                    if (response.data[t].entityProperty === response.data[t - 1].entityProperty) {
                        response.data[t].entityProperty = "";
                    }
                    if (response.data[t].isSettlementToday === '1') {
                        resultsIsSettlementToday.push(response.data[t]);
                    }
                    results.push(response.data[t]);
                }

            }
            setDataBox2(resultsIsSettlementToday);
            setDataBox2Original(results);
            setLoadBox2(true);
        }).catch((error) => {
            console.log(error);
        });

        informationService.storeProcedure('daySettlement', user.data.instance, dueDate, where).then((response) => {
            let resultBox1 = [];
            for (let k = 0; k < response.data.length; k++) {
                let entityPropertyId = response.data[k].entityPropertyId;
                if (k === 0) {
                    let resObj = {};
                    resObj.entityPropertyId = entityPropertyId;
                    resObj.entityProperty = response.data[k].entityProperty;
                    resObj.manager = response.data[k].manager;
                    resObj.totalLiquidado = Number(response.data[k].amountFx);
                    resObj.totalLiquidadoMep = Number(response.data[k].amountMep);
                    resObj.totalLiquidadCcl = Number(response.data[k].amountCcl);
                    resObj.result = [response.data[k]];
                    resultBox1.push(resObj);
                } else {
                    let existe = false;
                    for (let t = 0; t < resultBox1.length; t++) {
                        if (resultBox1[t].entityPropertyId === entityPropertyId) {
                            resultBox1[t].result.push(response.data[k]);
                            resultBox1[t].totalLiquidado = Number(resultBox1[t].totalLiquidado) + Number(response.data[k].amountFx);
                            resultBox1[t].totalLiquidadoMep = Number(resultBox1[t].totalLiquidadoMep) + Number(response.data[k].amountMep);
                            resultBox1[t].totalLiquidadCcl = Number(resultBox1[t].totalLiquidadCcl) + Number(response.data[k].amountCcl);
                            existe = true;
                        }
                    }
                    if (existe === false) {
                        let resObj = {};
                        resObj.entityPropertyId = entityPropertyId;
                        resObj.entityProperty = response.data[k].entityProperty;
                        resObj.manager = response.data[k].manager;
                        resObj.totalLiquidado = Number(response.data[k].amountFx);
                        resObj.totalLiquidadoMep = Number(response.data[k].amountMep);
                        resObj.totalLiquidadCcl = Number(response.data[k].amountCcl);
                        resObj.result = [response.data[k]];
                        resultBox1.push(resObj);
                    }
                }
            }

            dueDateFlag.setDate(dueDateFlag.getDate() - 1);
            let dueDate = formatDate(dueDateFlag);
            informationService.storeProcedure('entityBalanceArAsOf', user.data.instance, dueDate, where).then((response) => {
                setSaldoAnteriorBox1(response.data);
                setDataBox1(resultBox1);
                setLoadBox1(true);
            }).catch((error) => {
                console.log(error);
            });

        });

        informationService.storeProcedure('daySettlementNoPost', user.data.instance, dueDate, where).then((response) => {
            let resultOperacionesDia = [];
            for (let k = 0; k < response.data.length; k++) {
                let entityPropertyId = response.data[k].entityPropertyId;
                if (k === 0) {
                    let resObj = {};
                    resObj.entityPropertyId = entityPropertyId;
                    resObj.entityProperty = response.data[k].entityProperty;
                    resObj.manager = response.data[k].manager;
                    resObj.totalLiquidado = Number(response.data[k].amountFx);
                    resObj.totalLiquidadoMep = Number(response.data[k].amountMep);
                    resObj.totalLiquidadCcl = Number(response.data[k].amountCcl);
                    resObj.result = [response.data[k]];
                    resultOperacionesDia.push(resObj);
                } else {
                    let existe = false;
                    for (let t = 0; t < resultOperacionesDia.length; t++) {
                        if (resultOperacionesDia[t].entityPropertyId === entityPropertyId) {
                            resultOperacionesDia[t].result.push(response.data[k]);
                            resultOperacionesDia[t].totalLiquidado = Number(resultOperacionesDia[t].totalLiquidado) + Number(response.data[k].amountFx);
                            resultOperacionesDia[t].totalLiquidadoMep = Number(resultOperacionesDia[t].totalLiquidadoMep) + Number(response.data[k].amountMep);
                            resultOperacionesDia[t].totalLiquidadCcl = Number(resultOperacionesDia[t].totalLiquidadCcl) + Number(response.data[k].amountCcl);
                            existe = true;
                        }
                    }
                    if (existe === false) {
                        let resObj = {};
                        resObj.entityPropertyId = entityPropertyId;
                        resObj.entityProperty = response.data[k].entityProperty;
                        resObj.manager = response.data[k].manager;
                        resObj.totalLiquidado = Number(response.data[k].amountFx);
                        resObj.totalLiquidadoMep = Number(response.data[k].amountMep);
                        resObj.totalLiquidadCcl = Number(response.data[k].amountCcl);
                        resObj.result = [response.data[k]];
                        resultOperacionesDia.push(resObj);
                    }
                }
            }
            setOperacionesDiaNoPost(resultOperacionesDia);
            setLoadBox3(true);
        });

        informationService.storeProcedure('dayOperationAsOf', user.data.instance, dueDate, where).then((response) => {
            let results = [];
            for (let t = 0; t < response.data.length; t++) {
                response.data[t].entityPropertyFlag = response.data[t].entityProperty;
                if (t === 0) {
                    results.push(response.data[t]);
                } else {
                    if (response.data[t].entityPropertyFlag === response.data[t - 1].entityPropertyFlag) {
                        response.data[t].entityProperty = "";
                    }
                    results.push(response.data[t]);
                }
            }
            setOperacionesDia(results);
            setLoadBox4(true);
        });

        informationService.storeProcedure('dayPayables', user.data.instance, dueDate, where).then((response) => {
            let resultBox5 = [];
            for (let k = 0; k < response.data.length; k++) {
                let entityPropertyId = response.data[k].entityPropertyId;
                if (k === 0) {
                    let resObj = {};
                    resObj.entityPropertyId = entityPropertyId;
                    resObj.entityProperty = response.data[k].entityProperty;
                    resObj.manager = response.data[k].manager;
                    resObj.totalLiquidado = Number(response.data[k].amountFx);
                    resObj.totalLiquidadoMep = Number(response.data[k].amountMep);
                    resObj.totalLiquidadCcl = Number(response.data[k].amountCcl);
                    resObj.result = [response.data[k]];
                    resultBox5.push(resObj);
                } else {
                    let existe = false;
                    for (let t = 0; t < resultBox5.length; t++) {
                        if (resultBox5[t].entityPropertyId === entityPropertyId) {
                            resultBox5[t].result.push(response.data[k]);
                            resultBox5[t].totalLiquidado = Number(resultBox5[t].totalLiquidado) + Number(response.data[k].amountFx);
                            resultBox5[t].totalLiquidadoMep = Number(resultBox5[t].totalLiquidadoMep) + Number(response.data[k].amountMep);
                            resultBox5[t].totalLiquidadCcl = Number(resultBox5[t].totalLiquidadCcl) + Number(response.data[k].amountCcl);
                            existe = true;
                        }
                    }
                    if (existe === false) {
                        let resObj = {};
                        resObj.entityPropertyId = entityPropertyId;
                        resObj.entityProperty = response.data[k].entityProperty;
                        resObj.manager = response.data[k].manager;
                        resObj.totalLiquidado = Number(response.data[k].amountFx);
                        resObj.totalLiquidadoMep = Number(response.data[k].amountMep);
                        resObj.totalLiquidadCcl = Number(response.data[k].amountCcl);
                        resObj.result = [response.data[k]];
                        resultBox5.push(resObj);
                    }
                }
            }
            dueDateFlag1.setDate(dueDateFlag1.getDate() - 1);
            let dueDate = formatDate(dueDateFlag1);
            informationService.storeProcedure('entityBalanceApAsOf', user.data.instance, dueDate, where).then((response) => {
                setSaldoAnteriorBox5(response.data);
                setDataBox5(resultBox5);
                setLoadBox5(true);
            }).catch((error) => {
                console.log(error);
            });

        });

        informationService.storeProcedure('entityBalanceApAsOf', user.data.instance, dueDate, where).then((response) => {
            let results = [];
            let resultsIsSettlementToday = [];
            for (let t = 0; t < response.data.length; t++) {

                response.data[t].entityPropertyFlag = response.data[t].entityProperty;
                if (t === 0) {
                    if (response.data[t].isSettlementToday === '1') {
                        resultsIsSettlementToday.push(response.data[t]);
                    }
                    results.push(response.data[t]);
                } else {
                    if (response.data[t].entityProperty === response.data[t - 1].entityProperty) {
                        response.data[t].entityProperty = "";
                    }
                    if (response.data[t].isSettlementToday === '1') {
                        resultsIsSettlementToday.push(response.data[t]);
                    }
                    results.push(response.data[t]);
                }

            }
            setDataBox6(resultsIsSettlementToday);
            setDataBox6Original(results);
            setLoadBox6(true);
        }).catch((error) => {
            console.log(error);
        });

        informationService.storeProcedure('dayPayablesNoPost', user.data.instance, dueDate, where).then((response) => {
            let resultOperacionesDia = [];
            for (let k = 0; k < response.data.length; k++) {
                let entityPropertyId = response.data[k].entityPropertyId;
                if (k === 0) {
                    let resObj = {};
                    resObj.entityPropertyId = entityPropertyId;
                    resObj.entityProperty = response.data[k].entityProperty;
                    resObj.manager = response.data[k].manager;
                    resObj.totalLiquidado = Number(response.data[k].amountFx);
                    resObj.totalLiquidadoMep = Number(response.data[k].amountMep);
                    resObj.totalLiquidadCcl = Number(response.data[k].amountCcl);
                    resObj.result = [response.data[k]];
                    resultOperacionesDia.push(resObj);
                } else {
                    let existe = false;
                    for (let t = 0; t < resultOperacionesDia.length; t++) {
                        if (resultOperacionesDia[t].entityPropertyId === entityPropertyId) {
                            resultOperacionesDia[t].result.push(response.data[k]);
                            resultOperacionesDia[t].totalLiquidado = Number(resultOperacionesDia[t].totalLiquidado) + Number(response.data[k].amountFx);
                            resultOperacionesDia[t].totalLiquidadoMep = Number(resultOperacionesDia[t].totalLiquidadoMep) + Number(response.data[k].amountMep);
                            resultOperacionesDia[t].totalLiquidadCcl = Number(resultOperacionesDia[t].totalLiquidadCcl) + Number(response.data[k].amountCcl);
                            existe = true;
                        }
                    }
                    if (existe === false) {
                        let resObj = {};
                        resObj.entityPropertyId = entityPropertyId;
                        resObj.entityProperty = response.data[k].entityProperty;
                        resObj.manager = response.data[k].manager;
                        resObj.totalLiquidado = Number(response.data[k].amountFx);
                        resObj.totalLiquidadoMep = Number(response.data[k].amountMep);
                        resObj.totalLiquidadCcl = Number(response.data[k].amountCcl);
                        resObj.result = [response.data[k]];
                        resultOperacionesDia.push(resObj);
                    }
                }
            }
            setProveedoresDiaNoPost(resultOperacionesDia);
            setLoadBox7(true);
        });

        let whereAccountCashAsOf = [{
            idField: 'companyId',
            operator: '=',
            value: user.data.companyId
        },
        {
            idField: 'posted',
            operator: '=',
            value: "null"
        }
        ]
        informationService.storeProcedure('accountCashAsOf', user.data.instance, dueDate, whereAccountCashAsOf).then((response) => {
            let amountFx = 0;
            let amountMep = 0;
            let amountCcl = 0;
            for (let t = 0; t < response.data.length; t++) {
                if (response.data[t].amountFx) {
                    amountFx = amountFx + Number(response.data[t].amountFx)
                }
                if (response.data[t].amountMep) {
                    amountMep = amountMep + Number(response.data[t].amountMep)
                }
                if (response.data[t].amountCcl) {
                    amountCcl = amountCcl + Number(response.data[t].amountCcl)
                }
            }
            setTotalesBox8({
                amountFx,
                amountMep,
                amountCcl
            })
            setDataBox8(response.data);
            setLoadBox8(true);
        }).catch((error) => {
            console.log(error);
        });

    }

    const formattNumber = (value, respeatDecimal) => {
        let formatNumber;
        if (respeatDecimal)
            formatNumber = Number(value).toString().replace(/\./g, ',');
        else
            formatNumber = Number(value).toFixed(2).toString().replace(/\./g, ',');

        let valueSplit = formatNumber.split(',');


        if (respeatDecimal) {
            if (value === undefined)
                formatNumber = '0,0000000'
            else {
                let decimales = '0000000';
                if (valueSplit.length > 1) {
                    let tamValue = valueSplit[1].length;
                    let ceros = '';
                    let tam = 7 - tamValue;
                    for (let t = 0; t < tam; t++) {
                        ceros += '0';
                    }
                    decimales = valueSplit[1] + ceros;
                }

                formatNumber = `${Number(valueSplit[0]).toLocaleString('es-AR')},${decimales}`;
            }
        } else {
            if (valueSplit.length > 1) {
                formatNumber = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
            } else {
                formatNumber = `${Number(valueSplit[0]).toLocaleString('es-AR')},00`;
            }

        }

        return formatNumber;
    }

    const formatDateRender = (value) => {

        let valueSplit = value.split('-');

        return `${valueSplit[2]}/${valueSplit[1]}/${valueSplit[0].substring(2, 4)}`;
    }

    const getRowStyle = (isSubtotal, rowIndex) => {
        let baseColor = "white";

        if (isSubtotal) {
            baseColor = "rgba(0, 0, 0, 0.04)";
        } else {
            baseColor = rowIndex % 2 === 0 ? "white" : "rgba(0, 0, 0, 0.02)";
        }

        return {
            backgroundColor: baseColor,
            "&:hover": {
                backgroundColor: "#e6ffff", // color al pasar con el mouse
            },
        };
    };


    const viewDataBox1 = () => {
        let viewResponse = [];
        let totalGeneralPesos = 0;
        let totalGeneralMep = 0;
        let totalGeneralCcl = 0;
        let rowIndex = 0;

        dataBox1.forEach((item) => {

            viewResponse.push(<TableRow key={`entity-${item.entityProperty}`} sx={getRowStyle(false, rowIndex)}>
                <TableCell colSpan={"4"}>{item.entityProperty}</TableCell>
                <TableCell colSpan={"5"}> {item.manager ? `(${item.manager})` : ""}</TableCell>
            </TableRow>);
            rowIndex++;


            item.result.forEach((itemResult, idx) => {
                viewResponse.push(<TableRow key={`result-${item.entityProperty}-${idx}`}
                    sx={getRowStyle(false, rowIndex)}>
                    <TableCell>{itemResult.market}</TableCell>
                    <TableCell style={{ fontVariantNumeric: 'tabular-nums' }}>{formatDateRender(itemResult.date)}</TableCell>
                    <TableCell>{itemResult.docName}</TableCell>
                    <TableCell>{itemResult.trxProp}</TableCell>
                    <TableCell>{itemResult.itemPropertyName} {itemResult.itemName}</TableCell>
                    <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(itemResult.qty) < 0 ? "red" : "black" }} align='right'>{formattNumber(itemResult.qty)}</TableCell>
                    <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(itemResult.amountFx) < 0 ? "red" : "black" }} align="right">
                        <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                            <span style={{ marginRight: '4px' }}>$</span>
                            <span>{formattNumber(itemResult.amountFx)}</span>
                        </div>
                    </TableCell>
                    <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(itemResult.amountMep) < 0 ? "red" : "black" }} align="right">
                        <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                            <span>USD</span>
                            <span>{formattNumber(itemResult.amountMep)}</span>
                        </div>
                    </TableCell>
                    <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(itemResult.amountCcl) < 0 ? "red" : "black" }} align="right">
                        <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                            <span>USD</span>
                            <span>{formattNumber(itemResult.amountCcl)}</span>
                        </div>
                    </TableCell>
                </TableRow>);
                rowIndex++;
            })

            viewResponse.push(<TableRow key={`subtotal-${item.entityProperty}`}
                sx={getRowStyle(true, rowIndex)}>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell>A LIQUIDAR</TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.totalLiquidado) < 0 ? "red" : "black" }} align="right">
                    <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <span style={{ marginRight: '4px' }}>$</span>
                        <span>{formattNumber(item.totalLiquidado)}</span>
                    </div>
                </TableCell>
                <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.totalLiquidadoMep) < 0 ? "red" : "black" }} align="right">
                    <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <span>USD</span>
                        <span>{formattNumber(item.totalLiquidadoMep)}</span>
                    </div>
                </TableCell>
                <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.totalLiquidadCcl) < 0 ? "red" : "black" }} align="right">
                    <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <span>USD</span>
                        <span>{formattNumber(item.totalLiquidadCcl)}</span>
                    </div>
                </TableCell>
            </TableRow>)
            rowIndex++;
            let saldoAnteriorMep = 0;
            let saldiAnteriorCcl = 0;
            let saldoAnteriorFx = 0;
            saldoAnteriorBox1.forEach((itemSaldoAnterior => {
                if (Number(itemSaldoAnterior.entityPropertyId) === Number(item.entityPropertyId)) {
                    if (itemSaldoAnterior.statusId === '1') {
                        saldoAnteriorMep = itemSaldoAnterior.amountMep;
                        saldiAnteriorCcl = itemSaldoAnterior.amountCcl;
                        saldoAnteriorFx = itemSaldoAnterior.amountFx;
                    }
                }
            }))

            viewResponse.push(<TableRow key={`subtotal-${item.entityProperty}`}
                sx={getRowStyle(true, rowIndex)}>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell>SALDO ANTERIOR</TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(saldoAnteriorFx) < 0 ? "red" : "black" }} align="right">
                    <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <span style={{ marginRight: '4px' }}>$</span>
                        <span>{formattNumber(saldoAnteriorFx)}</span>
                    </div>
                </TableCell>
                <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(saldoAnteriorMep) < 0 ? "red" : "black" }} align="right">
                    <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <span>USD</span>
                        <span>{formattNumber(saldoAnteriorMep)}</span>
                    </div>
                </TableCell>
                <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(saldiAnteriorCcl) < 0 ? "red" : "black" }} align="right">
                    <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <span>USD</span>
                        <span>{formattNumber(saldiAnteriorCcl)}</span>
                    </div>
                </TableCell>
            </TableRow>)
            rowIndex++;
            let saldoActualPesos = Number(item.totalLiquidado) + Number(saldoAnteriorFx);
            let saldoActualDolar = Number(item.totalLiquidadoMep) + Number(saldoAnteriorMep);
            let saldoActualCable = Number(item.totalLiquidadCcl) + Number(saldiAnteriorCcl);
            totalGeneralPesos = Number(totalGeneralPesos) + Number(item.totalLiquidado);
            totalGeneralMep = Number(totalGeneralMep) + Number(item.totalLiquidadoMep);
            totalGeneralCcl = Number(totalGeneralCcl) + Number(item.totalLiquidadCcl);
            viewResponse.push(<TableRow key={`subtotal-${item.entityProperty}`}
                sx={getRowStyle(true, rowIndex)}>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell>SALDO ACTUAL</TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(saldoActualPesos) < 0 ? "red" : "black" }} align="right">
                    <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <span style={{ marginRight: '4px' }}>$</span>
                        <span>{formattNumber(saldoActualPesos)}</span>
                    </div>
                </TableCell>
                <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(saldoActualDolar) < 0 ? "red" : "black" }} align="right">
                    <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <span>USD</span>
                        <span>{formattNumber(saldoActualDolar)}</span>
                    </div>
                </TableCell>
                <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(saldoActualCable) < 0 ? "red" : "black" }} align="right">
                    <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <span>USD</span>
                        <span>{formattNumber(saldoActualCable)}</span>
                    </div>
                </TableCell>
            </TableRow>)
            rowIndex++;
        })
        viewResponse.push(<TableRow
            sx={getRowStyle(true, rowIndex)}>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell>TOTAL A LIQUIDAR</TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(totalGeneralPesos) < 0 ? "red" : "black" }} align="right">
                <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <span style={{ marginRight: '4px' }}>$</span>
                    <span>{formattNumber(totalGeneralPesos)}</span>
                </div>
            </TableCell>
            <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(totalGeneralMep) < 0 ? "red" : "black" }} align="right">
                <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <span>USD</span>
                    <span>{formattNumber(totalGeneralMep)}</span>
                </div>
            </TableCell>
            <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(totalGeneralCcl) < 0 ? "red" : "black" }} align="right">
                <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <span>USD</span>
                    <span>{formattNumber(totalGeneralCcl)}</span>
                </div>
            </TableCell>
        </TableRow>)
        rowIndex++;
        return viewResponse;
    }

    const viewDataBox3 = () => {
        let viewResponse = [];
        let rowIndex = 0;
        operacionesDiaNoPost.forEach((item) => {
            viewResponse.push(<TableRow sx={getRowStyle(false, rowIndex)}>
                <TableCell colSpan={"4"}>{item.entityProperty}</TableCell>
                <TableCell colSpan={"5"}> {item.manager ? `(${item.manager})` : ""}</TableCell>
            </TableRow>);
            rowIndex++;
            item.result.forEach((itemResult) => {
                viewResponse.push(<TableRow sx={getRowStyle(false, rowIndex)}>
                    <TableCell>{itemResult.market}</TableCell>
                    <TableCell style={{ fontVariantNumeric: 'tabular-nums' }}>{formatDateRender(itemResult.date)}</TableCell>
                    <TableCell>{itemResult.docName}</TableCell>
                    <TableCell>{itemResult.trxProp}</TableCell>
                    <TableCell>{itemResult.itemPropertyName} {itemResult.itemName}</TableCell>
                    <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(itemResult.qty) < 0 ? "red" : "black" }} align='right'>{formattNumber(itemResult.qty)}</TableCell>
                    <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(itemResult.amountFx) < 0 ? "red" : "black" }} align="right">
                        <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                            <span style={{ marginRight: '4px' }}>$</span>
                            <span>{formattNumber(itemResult.amountFx)}</span>
                        </div>
                    </TableCell>
                    <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(itemResult.amountMep) < 0 ? "red" : "black" }} align="right">
                        <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                            <span>USD</span>
                            <span>{formattNumber(itemResult.amountMep)}</span>
                        </div>
                    </TableCell>
                    <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(itemResult.amountCcl) < 0 ? "red" : "black" }} align="right">
                        <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                            <span>USD</span>
                            <span>{formattNumber(itemResult.amountCcl)}</span>
                        </div>
                    </TableCell>
                </TableRow>);
                rowIndex++;
            })

            viewResponse.push(<TableRow sx={getRowStyle(true, rowIndex)}>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell>A LIQUIDAR</TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.totalLiquidado) < 0 ? "red" : "black" }} align="right">
                    <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <span style={{ marginRight: '4px' }}>$</span>
                        <span>{formattNumber(item.totalLiquidado)}</span>
                    </div>
                </TableCell>
                <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.totalLiquidadoMep) < 0 ? "red" : "black" }} align="right">
                    <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <span>USD</span>
                        <span>{formattNumber(item.totalLiquidadoMep)}</span>
                    </div>
                </TableCell>
                <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.totalLiquidadCcl) < 0 ? "red" : "black" }} align="right">
                    <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <span>USD</span>
                        <span>{formattNumber(item.totalLiquidadCcl)}</span>
                    </div>
                </TableCell>
            </TableRow>)
            rowIndex++;
        })

        return viewResponse;
    }

    const viewDataBox7 = () => {
        let viewResponse = [];
        let rowIndex = 0;
        proveedoresDiaNoPost.forEach((item) => {
            viewResponse.push(<TableRow sx={getRowStyle(false, rowIndex)}>
                <TableCell colSpan={"4"}>{item.entityProperty}</TableCell>
            </TableRow>);
            item.result.forEach((itemResult) => {
                viewResponse.push(<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell>{itemResult.market}</TableCell>
                    <TableCell style={{ fontVariantNumeric: 'tabular-nums', }}>{formatDateRender(itemResult.date)}</TableCell>
                    <TableCell>{itemResult.docName}</TableCell>
                    <TableCell>{itemResult.trxProp}</TableCell>
                    <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(itemResult.amountFx) < 0 ? "red" : "black" }} align="right">
                        <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                            <span style={{ marginRight: '4px' }}>$</span>
                            <span>{formattNumber(itemResult.amountFx)}</span>
                        </div>
                    </TableCell>
                    <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(itemResult.amountMep) < 0 ? "red" : "black" }} align="right">
                        <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                            <span>USD</span>
                            <span>{formattNumber(itemResult.amountMep)}</span>
                        </div>
                    </TableCell>
                    <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(itemResult.amountCcl) < 0 ? "red" : "black" }} align="right">
                        <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                            <span>USD</span>
                            <span>{formattNumber(itemResult.amountCcl)}</span>
                        </div>
                    </TableCell>
                </TableRow>);
                rowIndex++;
            })

            viewResponse.push(<TableRow sx={getRowStyle(true, rowIndex)}>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell>A LIQUIDAR</TableCell>
                <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.totalLiquidado) < 0 ? "red" : "black" }} align="right">
                    <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <span style={{ marginRight: '4px' }}>$</span>
                        <span>{formattNumber(item.totalLiquidado)}</span>
                    </div>
                </TableCell>
                <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.totalLiquidadoMep) < 0 ? "red" : "black" }} align="right">
                    <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <span>USD</span>
                        <span>{formattNumber(item.totalLiquidadoMep)}</span>
                    </div>
                </TableCell>
                <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.totalLiquidadCcl) < 0 ? "red" : "black" }} align="right">
                    <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <span>USD</span>
                        <span>{formattNumber(item.totalLiquidadCcl)}</span>
                    </div>
                </TableCell>
            </TableRow>)
        })

        return viewResponse;
    }

    const viewDataBox5 = () => {
        let viewResponse = [];
        let totalGeneralPesos = 0;
        let totalGeneralMep = 0;
        let totalGeneralCcl = 0;
        let rowIndex = 0;

        dataBox5.forEach((item) => {
            viewResponse.push(<TableRow sx={getRowStyle(false, rowIndex)}>
                <TableCell colSpan={"4"}>{item.entityProperty}</TableCell>
                <TableCell colSpan={"5"}> {item.manager ? `(${item.manager})` : ""}</TableCell>
            </TableRow>);
            rowIndex++;
            item.result.forEach((itemResult) => {
                viewResponse.push(<TableRow sx={getRowStyle(false, rowIndex)}>
                    <TableCell style={{ fontVariantNumeric: 'tabular-nums', }}>{formatDateRender(itemResult.date)}</TableCell>
                    <TableCell>{itemResult.docName}</TableCell>
                    <TableCell>{itemResult.trxProp}</TableCell>
                    <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(itemResult.amountFx) < 0 ? "red" : "black" }} align="right">
                        <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                            <span style={{ marginRight: '4px' }}>$</span>
                            <span>{formattNumber(itemResult.amountFx)}</span>
                        </div>
                    </TableCell>
                    <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(itemResult.amountMep) < 0 ? "red" : "black" }} align="right">
                        <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                            <span>USD</span>
                            <span>{formattNumber(itemResult.amountMep)}</span>
                        </div>
                    </TableCell>
                    <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(itemResult.amountCcl) < 0 ? "red" : "black" }} align="right">
                        <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                            <span>USD</span>
                            <span>{formattNumber(itemResult.amountCcl)}</span>
                        </div>
                    </TableCell>
                </TableRow>);
                rowIndex++;
            })

            viewResponse.push(<TableRow sx={getRowStyle(true, rowIndex)}>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell>A PAGAR</TableCell>
                <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.totalLiquidado) < 0 ? "red" : "black" }} align="right">
                    <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <span style={{ marginRight: '4px' }}>$</span>
                        <span>{formattNumber(item.totalLiquidado)}</span>
                    </div>
                </TableCell>
                <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.totalLiquidadoMep) < 0 ? "red" : "black" }} align="right">
                    <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <span>USD</span>
                        <span>{formattNumber(item.totalLiquidadoMep)}</span>
                    </div>
                </TableCell>
                <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.totalLiquidadCcl) < 0 ? "red" : "black" }} align="right">
                    <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <span>USD</span>
                        <span>{formattNumber(item.totalLiquidadCcl)}</span>
                    </div>
                </TableCell>
            </TableRow>)
            rowIndex++;
            let saldoAnteriorMep = 0;
            let saldiAnteriorCcl = 0;
            let saldoAnteriorFx = 0;
            saldoAnteriorBox5.forEach((itemSaldoAnterior => {
                if (Number(itemSaldoAnterior.entityPropertyId) === Number(item.entityPropertyId)) {
                    if (itemSaldoAnterior.statusId === '1') {
                        saldoAnteriorMep = itemSaldoAnterior.amountMep;
                        saldiAnteriorCcl = itemSaldoAnterior.amountCcl;
                        saldoAnteriorFx = itemSaldoAnterior.amountFx;
                    }
                }
            }))
            viewResponse.push(<TableRow sx={getRowStyle(true, rowIndex)}>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell>SALDO ANTERIOR</TableCell>
                <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(saldoAnteriorFx) < 0 ? "red" : "black" }} align="right">
                    <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <span style={{ marginRight: '4px' }}>$</span>
                        <span>{formattNumber(saldoAnteriorFx)}</span>
                    </div>
                </TableCell>
                <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(saldoAnteriorMep) < 0 ? "red" : "black" }} align="right">
                    <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <span>USD</span>
                        <span>{formattNumber(saldoAnteriorMep)}</span>
                    </div>
                </TableCell>
                <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(saldiAnteriorCcl) < 0 ? "red" : "black" }} align="right">
                    <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <span>USD</span>
                        <span>{formattNumber(saldiAnteriorCcl)}</span>
                    </div>
                </TableCell>
            </TableRow>)
            rowIndex++;
            let saldoActualPesos = Number(item.totalLiquidado) + Number(saldoAnteriorFx);
            let saldoActualDolar = Number(item.totalLiquidadoMep) + Number(saldoAnteriorMep);
            let saldoActualCable = Number(item.totalLiquidadCcl) + Number(saldiAnteriorCcl);
            totalGeneralPesos = Number(totalGeneralPesos) + Number(item.totalLiquidado);
            totalGeneralMep = Number(totalGeneralMep) + Number(item.totalLiquidadoMep);
            totalGeneralCcl = Number(totalGeneralCcl) + Number(item.totalLiquidadCcl);
            viewResponse.push(<TableRow sx={getRowStyle(true, rowIndex)}>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell>SALDO ACTUAL</TableCell>
                <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(saldoActualPesos) < 0 ? "red" : "black" }} align="right">
                    <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <span style={{ marginRight: '4px' }}>$</span>
                        <span>{formattNumber(saldoActualPesos)}</span>
                    </div>
                </TableCell>
                <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(saldoActualDolar) < 0 ? "red" : "black" }} align="right">
                    <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <span>USD</span>
                        <span>{formattNumber(saldoActualDolar)}</span>
                    </div>
                </TableCell>
                <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(saldoActualCable) < 0 ? "red" : "black" }} align="right">
                    <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <span>USD</span>
                        <span>{formattNumber(saldoActualCable)}</span>
                    </div>
                </TableCell>
            </TableRow>)
            rowIndex++;
        })
        viewResponse.push(<TableRow sx={getRowStyle(true, rowIndex)}>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell>TOTAL A PAGAR</TableCell>
            <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(totalGeneralPesos) < 0 ? "red" : "black" }} align="right">
                <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <span style={{ marginRight: '4px' }}>$</span>
                    <span>{formattNumber(totalGeneralPesos)}</span>
                </div>
            </TableCell>
            <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(totalGeneralMep) < 0 ? "red" : "black" }} align="right">
                <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <span>USD</span>
                    <span>{formattNumber(totalGeneralMep)}</span>
                </div>
            </TableCell>
            <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(totalGeneralCcl) < 0 ? "red" : "black" }} align="right">
                <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <span>USD</span>
                    <span>{formattNumber(totalGeneralCcl)}</span>
                </div>
            </TableCell>
        </TableRow>)
        rowIndex++;
        return viewResponse;
    }

    const handleFieldFilterChangeSwitch3 = (e) => {
        let value = e.target.value;
        setSwitchBox3(value);
        setLoadBox8(false);
        const user = AuthService.getCurrentUser();
        let whereAccountCashAsOf = [{
            idField: 'companyId',
            operator: '=',
            value: user.data.companyId
        },
        {
            idField: 'posted',
            operator: '=',
            value: value
        }
        ]

        let date = filterDate.split('-');
        let dueDateFlag = new Date(date[0], Number(date[1]) - 1, date[2]);

        let dueDate = formatDate(dueDateFlag);

        informationService.storeProcedure('accountCashAsOf', user.data.instance, dueDate, whereAccountCashAsOf).then((response) => {
            let amountFx = 0;
            let amountMep = 0;
            let amountCcl = 0;
            for (let t = 0; t < response.data.length; t++) {
                if (response.data[t].amountFx) {
                    amountFx = amountFx + Number(response.data[t].amountFx)
                }
                if (response.data[t].amountMep) {
                    amountMep = amountMep + Number(response.data[t].amountMep)
                }
                if (response.data[t].amountCcl) {
                    amountCcl = amountCcl + Number(response.data[t].amountCcl)
                }
            }
            setTotalesBox8({
                amountFx,
                amountMep,
                amountCcl
            })
            setDataBox8(response.data);
            setLoadBox8(true);
        }).catch((error) => {
            console.log(error);
        });

    }

    const handleFieldFilterChange = (e, idField) => {
        let value = e.target.value;
        if (idField === 'isSettlementToday') {
            value = e.target.checked;
            setSwitchBox2(value);
        } else {
            fieldFilter = {
                id: value
            }
        }


        let newFiltersValues = filtersValues.filter(filter => filter.idField !== idField);

        if (value !== "") {
            newFiltersValues = [...newFiltersValues, { idField, value }];
        }
        setFiltersValues(newFiltersValues);

        const updatedFiltersValues = [...newFiltersValues];

        if (updatedFiltersValues.length > 0) {
            let dataBox2Flag = [];
            for (let r = 0; r < dataBox2Original.length; r++) {
                let matchesAllFilters = true;
                for (let h = 0; h < updatedFiltersValues.length; h++) {
                    let valueFilter = null;
                    if (updatedFiltersValues[h].idField === 'isSettlementToday') {
                        valueFilter = updatedFiltersValues[h].value === true ? '1' : null;
                    } else {
                        valueFilter = updatedFiltersValues[h].value
                    }

                    if (valueFilter !== null) {
                        if (dataBox2Original[r][updatedFiltersValues[h].idField]) {
                            let value = dataBox2Original[r][updatedFiltersValues[h].idField].toUpperCase();
                            if (!value.includes(valueFilter.toUpperCase())) {
                                matchesAllFilters = false;
                                break;
                            }
                        }
                    }
                }
                if (matchesAllFilters) {
                    dataBox2Flag.push(dataBox2Original[r])
                }
            }
            setDataBox2(dataBox2Flag);
        } else {
            let arrayFlag = [];
            for (let r = 0; r < dataBox2Original.length; r++) {
                arrayFlag.push(dataBox2Original[r]);
            }
            setDataBox2(arrayFlag);
        }
    }

    const handleFieldFilterChangeBox6 = (e, idField) => {
        let value = e.target.value;
        if (idField === 'isSettlementToday') {
            value = e.target.checked;
            setSwitchBox6(value);
        } else {
            fieldFilterBox6 = {
                id: value
            }
        }

        let newFiltersValues = filtersValuesBox6.filter(filter => filter.idField !== idField);

        if (value !== "") {
            newFiltersValues = [...newFiltersValues, { idField, value }];
        }

        setFiltersValuesBox6(newFiltersValues);

        const updatedFiltersValues = [...newFiltersValues];

        if (updatedFiltersValues.length > 0) {
            let dataBox6Flag = [];
            for (let r = 0; r < dataBox6Original.length; r++) {
                let matchesAllFilters = true;
                for (let h = 0; h < updatedFiltersValues.length; h++) {
                    let valueFilter = null;
                    if (updatedFiltersValues[h].idField === 'isSettlementToday') {
                        valueFilter = updatedFiltersValues[h].value === true ? '1' : null;
                    } else {
                        valueFilter = updatedFiltersValues[h].value
                    }

                    if (valueFilter !== null) {
                        if (dataBox6Original[r][updatedFiltersValues[h].idField]) {
                            let value = dataBox6Original[r][updatedFiltersValues[h].idField].toUpperCase();
                            if (!value.includes(valueFilter.toUpperCase())) {
                                matchesAllFilters = false;
                                break;
                            }
                        }
                    }
                }
                if (matchesAllFilters) {
                    dataBox6Flag.push(dataBox6Original[r])
                }
            }
            setDataBox6(dataBox6Flag);
        } else {
            let arrayFlag = [];
            for (let r = 0; r < dataBox6Original.length; r++) {
                arrayFlag.push(dataBox6Original[r]);
            }
            setDataBox6(arrayFlag);
        }
    }

    return (
        <div style={{ overflowX: 'hidden' }}>
            <MenuApp />
            {!user.data.tradeAccountId && !user.data.managerId && (
                <>
                    <div style={{ marginTop: '4rem', marginLeft: '8px' }} className="mi-componente-material-ui">
                        <Grid item>
                            <Box display="flex" alignItems="center">
                                <DateComponent
                                    disabled={false}
                                    id='filterDate'
                                    name='Liquidación'
                                    value={filterDate}
                                    onChange={(newDate) => handleFieldChange({ target: { value: newDate } })}
                                    help={null}
                                    mode={'c'}
                                    design={null}
                                    view={null}
                                />
                                <Button
                                    variant="text"
                                    size="small"
                                    onClick={updateList}
                                    style={{ fontSize: "inherit", lineHeight: "inherit", color: 'black', textDecoration: "underline" }}
                                >
                                    <RefreshIcon />
                                </Button>
                            </Box>
                        </Grid>
                    </div>

                    <Box
                        sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'space-between',
                            //gap: 2,
                            //marginTop: '1rem',
                        }}
                    >


                        <Box
                            sx={{
                                flex: '1 1 48%', // se ajusta en pantallas grandes
                                minWidth: '320px', // ancho mínimo en pantallas chicas
                                //border: 1,
                                //borderColor: "rgb(0 0 0 / 13%)",
                                borderRadius: '4px',
                                padding: "4px",
                                margin: "4px",
                                backgroundColor: "rgba(0, 0, 0, 0.02)"
                            }}
                        >
                            <Box>
                                <Box display="flex" alignItems="center">
                                    <IconButton onClick={() => handleToggleCollapseBox1()}>
                                        {collapsedStatesBox1 ? (<ExpandLessIcon />) : (<ExpandMoreIcon />)}
                                    </IconButton>
                                    <Typography
                                        fontSize={'0.75rem'}
                                        fontWeight={'600'}
                                        component="div"
                                    >
                                        Operaciones a Liquidar
                                    </Typography>
                                </Box>
                                {collapsedStatesBox1 && (
                                    <div style={{ marginTop: '4px' }}>

                                        {!loadBox1 && (
                                            <CircularProgress size={60} />
                                        )}
                                        {loadBox1 && (
                                            <TableContainer component={Paper} sx={{ maxHeight: '447px', overflowY: 'auto' }}>
                                                <Table sx={{ minWidth: 800, height: '100%' }} aria-label="simple table">
                                                    <TableHead>
                                                        <TableRow style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: 'rgb(50 59 152)' }}>
                                                            <TableCell style={{ color: 'white' }}>Mercado</TableCell>
                                                            <TableCell style={{ color: 'white' }}>Fecha</TableCell>
                                                            <TableCell style={{ color: 'white' }}>Número</TableCell>
                                                            <TableCell style={{ color: 'white' }}>Comprobante</TableCell>
                                                            <TableCell style={{ color: 'white' }}>Especie</TableCell>
                                                            <TableCell style={{ color: 'white', textAlign: 'center' }}>Cantidad</TableCell>
                                                            <TableCell style={{ color: 'white', textAlign: 'center', minWidth: '12ch' }}>PESOS</TableCell>
                                                            <TableCell style={{ color: 'white', textAlign: 'center', minWidth: '12ch' }}>MEP</TableCell>
                                                            <TableCell style={{ color: 'white', textAlign: 'center', minWidth: '12ch' }}>CABLE</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {viewDataBox1()}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        )}
                                    </div>
                                )}
                            </Box>
                        </Box>

                        <Box
                            sx={{
                                flex: '1 1 48%', // se ajusta en pantallas grandes
                                minWidth: '320px', // ancho mínimo en pantallas chicas
                                //border: 1,
                                //borderColor: "rgb(0 0 0 / 13%)",
                                borderRadius: '4px',
                                padding: "4px",
                                margin: "4px",
                                backgroundColor: "rgba(0, 0, 0, 0.02)"
                            }}
                        >
                            <Box>
                                <Box display="flex" alignItems="center">
                                    <IconButton onClick={() => handleToggleCollapseBox2()}>
                                        {collapsedStatesBox2 ? (<ExpandLessIcon />) : (<ExpandMoreIcon />)}
                                    </IconButton>
                                    <Typography
                                        fontSize={'0.75rem'}
                                        fontWeight={'600'}
                                        component="div"
                                    >
                                        Saldos
                                    </Typography>
                                </Box>

                                {collapsedStatesBox2 && (
                                    <Box sx={{ width: '100%', overflowX: 'auto' }}>
                                        <div style={{ marginTop: '4px' }}>
                                            <div className="mi-componente-material-ui">
                                                <Grid container sx={{ m: 0.5 }} xs={12} item>
                                                    <Grid item>
                                                        <Box display="flex" alignItems="center">
                                                            <TextField
                                                                value={fieldFilter.Symbol}
                                                                onChange={(event) => handleFieldFilterChange(event, `entityPropertyFlag`)}
                                                                InputProps={{
                                                                    style: {
                                                                        height: '34px',
                                                                        fontSize: "inherit",
                                                                        lineHeight: "inherit"
                                                                    }
                                                                }}
                                                            />
                                                        </Box>
                                                    </Grid>
                                                    <Grid item>
                                                        <Box
                                                            display="flex"
                                                            alignItems="center"
                                                            marginLeft="20px"
                                                            flexWrap="nowrap"
                                                        >
                                                            <FormControlLabel
                                                                sx={{
                                                                    margin: 0,
                                                                    whiteSpace: "nowrap"
                                                                }}
                                                                control={
                                                                    <Switch
                                                                        checked={switchBox2}
                                                                        id="isSettlementToday"
                                                                    />
                                                                }
                                                                label={
                                                                    <span style={{ fontSize: "inherit", fontWeight: 600 }}>
                                                                        Liquida Hoy
                                                                    </span>
                                                                }
                                                                value={switchBox2}
                                                                onChange={(event) =>
                                                                    handleFieldFilterChange(event, "isSettlementToday")
                                                                }
                                                            />
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </div>

                                            {!loadBox2 && (
                                                <CircularProgress size={60} />
                                            )}
                                            {loadBox2 && (
                                                <TableContainer
                                                    component={Paper}
                                                    sx={{
                                                        maxHeight: 400,
                                                        overflowX: 'auto',
                                                        overflowY: 'auto',
                                                        width: '100%',
                                                    }}
                                                >
                                                    <Table aria-label="simple table" sx={{ minWidth: 650 }}>
                                                        <TableHead
                                                            sx={{
                                                                position: "sticky",
                                                                top: 0,
                                                                backgroundColor: "white",
                                                                zIndex: 2
                                                            }}
                                                        >

                                                            <TableRow style={{ backgroundColor: 'rgb(50 59 152)' }}>
                                                                <TableCell style={{ color: 'white' }}>Comitente</TableCell>
                                                                <TableCell style={{ color: 'white' }}>Estado</TableCell>
                                                                <TableCell style={{ color: 'white', textAlign: 'center' }}>PESOS</TableCell>
                                                                <TableCell style={{ color: 'white', textAlign: 'center' }}>MEP</TableCell>
                                                                <TableCell style={{ color: 'white', textAlign: 'center' }}>CABLE</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {dataBox2.map((item, index) => (
                                                                <TableRow sx={getRowStyle(false, index)} key={index}>
                                                                    <TableCell>{item.entityProperty}</TableCell>
                                                                    <TableCell>{item.status}</TableCell>
                                                                    <TableCell
                                                                        style={{
                                                                            fontVariantNumeric: 'tabular-nums',
                                                                            letterSpacing: "0.01rem",
                                                                            color: Number(item.amountFx) < 0 ? "red" : "black"
                                                                        }}
                                                                        align="right"
                                                                    >
                                                                        <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                                            <span>$</span>
                                                                            <span>{formattNumber(item.amountFx)}</span>
                                                                        </div>
                                                                    </TableCell>

                                                                    <TableCell
                                                                        style={{
                                                                            fontVariantNumeric: 'tabular-nums',
                                                                            letterSpacing: "0.01rem",
                                                                            color: Number(item.amountMep) < 0 ? "red" : "black"
                                                                        }}
                                                                        align="right"
                                                                    >
                                                                        <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                                            <span>USD</span>
                                                                            <span>{formattNumber(item.amountMep)}</span>
                                                                        </div>
                                                                    </TableCell>
                                                                    <TableCell
                                                                        style={{
                                                                            fontVariantNumeric: 'tabular-nums',
                                                                            letterSpacing: "0.01rem",
                                                                            color: Number(item.amountCcl) < 0 ? "red" : "black"
                                                                        }}
                                                                        align="right"
                                                                    >
                                                                        <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                                            <span>USD</span>
                                                                            <span>{formattNumber(item.amountCcl)}</span>
                                                                        </div>
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            )}
                                        </div>
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    </Box>

                    <Box
                        sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'space-between',
                            //gap: 2,
                            //marginTop: '1rem',
                        }}
                    >
                        <Box
                            sx={{
                                flex: '1 1 48%', // se ajusta en pantallas grandes
                                minWidth: '320px', // ancho mínimo en pantallas chicas
                                //border: 1,
                                //borderColor: "rgb(0 0 0 / 13%)",
                                borderRadius: '4px',
                                padding: "4px",
                                margin: "4px",
                                backgroundColor: "rgba(0, 0, 0, 0.02)"
                            }}
                        >
                            <Box>
                                <Box display="flex" alignItems="center">
                                    <IconButton onClick={() => handleToggleCollapseBox3()}>
                                        {collapsedStatesBox3 ? (<ExpandLessIcon />) : (<ExpandMoreIcon />)}
                                    </IconButton>
                                    <Typography
                                        fontSize={'0.75rem'}
                                        fontWeight={'600'}
                                        component="div"
                                    >
                                        Operaciones del día (No Post)
                                    </Typography>
                                </Box>
                                {collapsedStatesBox3 && (
                                    <Box sx={{ width: '100%', overflowX: 'auto' }}>
                                        <div style={{ marginTop: '4px' }}>

                                            {!loadBox3 && (
                                                <CircularProgress size={60} />
                                            )}
                                            {loadBox3 && (
                                                <TableContainer component={Paper} sx={{ maxHeight: '400px', overflowY: 'auto' }}>
                                                    <Table sx={{ minWidth: 800, height: '100%' }} aria-label="simple table">
                                                        <TableHead>
                                                            <TableRow style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: 'rgb(50 59 152)' }}>
                                                                <TableCell style={{ color: 'white' }}>Mercado</TableCell>
                                                                <TableCell style={{ color: 'white' }}>Fecha</TableCell>
                                                                <TableCell style={{ color: 'white' }}>Número</TableCell>
                                                                <TableCell style={{ color: 'white' }}>Comprobante</TableCell>
                                                                <TableCell style={{ color: 'white' }}>Especie</TableCell>
                                                                <TableCell style={{ color: 'white', textAlign: 'center' }}>Cantidad</TableCell>
                                                                <TableCell style={{ color: 'white', textAlign: 'center', minWidth: '12ch' }}>PESOS</TableCell>
                                                                <TableCell style={{ color: 'white', textAlign: 'center', minWidth: '12ch' }}>MEP</TableCell>
                                                                <TableCell style={{ color: 'white', textAlign: 'center', minWidth: '12ch' }}>CABLE</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {viewDataBox3()}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            )}
                                        </div>
                                    </Box>
                                )}

                            </Box>


                        </Box>

                        <Box
                            sx={{
                                flex: '1 1 48%', // se ajusta en pantallas grandes
                                minWidth: '320px', // ancho mínimo en pantallas chicas
                                //border: 1,
                                //borderColor: "rgb(0 0 0 / 13%)",
                                borderRadius: '4px',
                                padding: "4px",
                                margin: "4px",
                                backgroundColor: "rgba(0, 0, 0, 0.02)"
                            }}
                        >
                            <Box>
                                <Box display="flex" alignItems="center">
                                    <IconButton onClick={() => handleToggleCollapseBox4()}>
                                        {collapsedStatesBox4 ? (<ExpandLessIcon />) : (<ExpandMoreIcon />)}
                                    </IconButton>
                                    <Typography
                                        fontSize={'0.75rem'}
                                        fontWeight={'600'}
                                        component="div"
                                    >
                                        Operaciones del día
                                    </Typography>
                                </Box>

                                {collapsedStatesBox4 && (
                                    <Box sx={{ width: '100%', overflowX: 'auto' }}>
                                        <div style={{ marginTop: '4px' }}>

                                            {!loadBox4 && (
                                                <CircularProgress size={60} />
                                            )}
                                            {loadBox4 && (
                                                <TableContainer
                                                    component={Paper}
                                                    sx={{
                                                        maxHeight: 400,
                                                        overflowX: 'auto',
                                                        overflowY: 'auto',
                                                        width: '100%',
                                                    }}
                                                >
                                                    <Table aria-label="simple table" sx={{ minWidth: 650 }}>
                                                        <TableHead
                                                            sx={{
                                                                position: "sticky",
                                                                top: 0,
                                                                backgroundColor: "white",
                                                                zIndex: 2
                                                            }}
                                                        >

                                                            <TableRow style={{ backgroundColor: 'rgb(50 59 152)' }}>
                                                                <TableCell style={{ color: 'white' }}>Cliente</TableCell>
                                                                <TableCell style={{ color: 'white' }}>Instrumento</TableCell>
                                                                <TableCell style={{ color: 'white' }}>Mercado</TableCell>
                                                                <TableCell style={{ color: 'white' }}>Fecha</TableCell>
                                                                <TableCell style={{ color: 'white' }}>Post</TableCell>
                                                                <TableCell style={{ color: 'white', textAlign: 'center' }}>Cantidad</TableCell>
                                                                <TableCell style={{ color: 'white', textAlign: 'center' }}>Garantía</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {operacionesDia.map((item, index) => (
                                                                <TableRow sx={getRowStyle(false, index)} key={index}>
                                                                    <TableCell>{item.entityProperty}</TableCell>
                                                                    <TableCell>{item.item}</TableCell>
                                                                    <TableCell>{item.market}</TableCell>
                                                                    <TableCell style={{ fontVariantNumeric: 'tabular-nums', }}>{item.date}</TableCell>
                                                                    <TableCell>{item.posted}</TableCell>
                                                                    <TableCell
                                                                        style={{
                                                                            fontVariantNumeric: 'tabular-nums',
                                                                            letterSpacing: "0.01rem",
                                                                            color: Number(item.qty) < 0 ? "red" : "black"
                                                                        }}
                                                                        align="right"
                                                                    >
                                                                        <div style={{ width: '100%' }}>
                                                                            <span>{formattNumber(item.qty, true)}</span>
                                                                        </div>
                                                                    </TableCell>

                                                                    <TableCell
                                                                        style={{
                                                                            fontVariantNumeric: 'tabular-nums',
                                                                            letterSpacing: "0.01rem",
                                                                            color: Number(item.qtyGuarantee) < 0 ? "red" : "black"
                                                                        }}
                                                                        align="right"
                                                                    >
                                                                        <div style={{ width: '100%' }}>
                                                                            <span>{formattNumber(item.qtyGuarantee, true)}</span>
                                                                        </div>
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            )}
                                        </div>
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    </Box>

                    <Box
                        sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'space-between',
                            //gap: 2,
                            //marginTop: '1rem',
                        }}
                    >


                        <Box
                            sx={{
                                flex: '1 1 48%', // se ajusta en pantallas grandes
                                minWidth: '320px', // ancho mínimo en pantallas chicas
                                //border: 1,
                                //borderColor: "rgb(0 0 0 / 13%)",
                                borderRadius: '4px',
                                padding: "4px",
                                margin: "4px",
                                backgroundColor: "rgba(0, 0, 0, 0.02)"
                            }}
                        >
                            <Box>
                                <Box display="flex" alignItems="center">
                                    <IconButton onClick={() => handleToggleCollapseBox5()}>
                                        {collapsedStatesBox5 ? (<ExpandLessIcon />) : (<ExpandMoreIcon />)}
                                    </IconButton>
                                    <Typography
                                        fontSize={'0.75rem'}
                                        fontWeight={'600'}
                                        component="div"
                                    >
                                        Vencimientos a Pagar
                                    </Typography>
                                </Box>
                                {collapsedStatesBox5 && (
                                    <div style={{ marginTop: '4px' }}>

                                        {!loadBox5 && (
                                            <CircularProgress size={60} />
                                        )}
                                        {loadBox5 && (
                                            <TableContainer component={Paper} sx={{ maxHeight: '447px', overflowY: 'auto' }}>
                                                <Table sx={{ minWidth: 800, height: '100%' }} aria-label="simple table">
                                                    <TableHead>
                                                        <TableRow style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: 'rgb(50 59 152)' }}>
                                                            <TableCell style={{ color: 'white' }}>Fecha</TableCell>
                                                            <TableCell style={{ color: 'white' }}>Número</TableCell>
                                                            <TableCell style={{ color: 'white' }}>Comprobante</TableCell>
                                                            <TableCell style={{ color: 'white', textAlign: 'center', minWidth: '12ch' }}>PESOS</TableCell>
                                                            <TableCell style={{ color: 'white', textAlign: 'center', minWidth: '12ch' }}>MEP</TableCell>
                                                            <TableCell style={{ textAlign: 'center', minWidth: '12ch' }}>CABLE</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {viewDataBox5()}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        )}
                                    </div>
                                )}
                            </Box>
                        </Box>

                        <Box
                            sx={{
                                flex: '1 1 48%', // se ajusta en pantallas grandes
                                minWidth: '320px', // ancho mínimo en pantallas chicas
                                //border: 1,
                                //borderColor: "rgb(0 0 0 / 13%)",
                                borderRadius: '4px',
                                padding: "4px",
                                margin: "4px",
                                backgroundColor: "rgba(0, 0, 0, 0.02)"
                            }}
                        >
                            <Box>
                                <Box display="flex" alignItems="center">
                                    <IconButton onClick={() => handleToggleCollapseBox6()}>
                                        {collapsedStatesBox6 ? (<ExpandLessIcon />) : (<ExpandMoreIcon />)}
                                    </IconButton>
                                    <Typography
                                        fontSize={'0.75rem'}
                                        fontWeight={'600'}
                                        component="div"
                                    >
                                        Saldos a Proveedores
                                    </Typography>
                                </Box>

                                {collapsedStatesBox6 && (
                                    <Box sx={{ width: '100%', overflowX: 'auto' }}>
                                        <div style={{ marginTop: '4px' }}>
                                            <div className="mi-componente-material-ui">
                                                <Grid container sx={{ m: 0.5 }} xs={12} item>
                                                    <Grid item>
                                                        <Box display="flex" alignItems="center">
                                                            <TextField
                                                                value={fieldFilterBox6.Symbol}
                                                                onChange={(event) => handleFieldFilterChangeBox6(event, `entityPropertyFlag`)}
                                                                InputProps={{
                                                                    style: {
                                                                        height: '34px',
                                                                        fontSize: "inherit",
                                                                        lineHeight: "inherit"
                                                                    }
                                                                }}
                                                            />
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs="auto">
                                                        <Box
                                                            display="flex"
                                                            alignItems="center"
                                                            marginLeft="20px"
                                                            flexWrap="nowrap"
                                                        >
                                                            <FormControlLabel
                                                                sx={{
                                                                    margin: 0,
                                                                    whiteSpace: "nowrap"
                                                                }}
                                                                control={
                                                                    <Switch
                                                                        checked={switchBox6}
                                                                        id="isSettlementToday"
                                                                    />
                                                                }
                                                                label={
                                                                    <span style={{ fontSize: "inherit", fontWeight: 600 }}>
                                                                        Vence Hoy
                                                                    </span>
                                                                }
                                                                value={switchBox6}
                                                                onChange={(event) =>
                                                                    handleFieldFilterChangeBox6(event, "isSettlementToday")
                                                                }
                                                            />
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </div>

                                            {!loadBox6 && (
                                                <CircularProgress size={60} />
                                            )}
                                            {loadBox6 && (
                                                <TableContainer
                                                    component={Paper}
                                                    sx={{
                                                        maxHeight: 400,
                                                        overflowX: 'auto',
                                                        overflowY: 'auto',
                                                        width: '100%',
                                                    }}
                                                >
                                                    <Table aria-label="simple table" sx={{ minWidth: 650 }}>
                                                        <TableHead
                                                            sx={{
                                                                position: "sticky",
                                                                top: 0,
                                                                backgroundColor: "white",
                                                                zIndex: 2
                                                            }}
                                                        >

                                                            <TableRow style={{ backgroundColor: 'rgb(50 59 152)' }}>
                                                                <TableCell style={{ color: 'white' }}>Proveedor</TableCell>
                                                                <TableCell style={{ color: 'white' }}>Estado</TableCell>
                                                                <TableCell style={{ color: 'white', textAlign: 'center' }}>PESOS</TableCell>
                                                                <TableCell style={{ color: 'white', textAlign: 'center' }}>MEP</TableCell>
                                                                <TableCell style={{ color: 'white', textAlign: 'center' }}>CABLE</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {dataBox6.map((item, index) => (
                                                                <TableRow sx={getRowStyle(false, index)} key={index}>
                                                                    <TableCell>{item.entityProperty}</TableCell>
                                                                    <TableCell>{item.status}</TableCell>
                                                                    <TableCell
                                                                        style={{
                                                                            fontVariantNumeric: 'tabular-nums',
                                                                            letterSpacing: "0.01rem",
                                                                            color: Number(item.amountFx) < 0 ? "red" : "black"
                                                                        }}
                                                                        align="right"
                                                                    >
                                                                        <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                                            <span>$</span>
                                                                            <span>{formattNumber(item.amountFx)}</span>
                                                                        </div>
                                                                    </TableCell>

                                                                    <TableCell
                                                                        style={{
                                                                            fontVariantNumeric: 'tabular-nums',
                                                                            letterSpacing: "0.01rem",
                                                                            color: Number(item.amountMep) < 0 ? "red" : "black"
                                                                        }}
                                                                        align="right"
                                                                    >
                                                                        <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                                            <span>USD</span>
                                                                            <span>{formattNumber(item.amountMep)}</span>
                                                                        </div>
                                                                    </TableCell>
                                                                    <TableCell
                                                                        style={{
                                                                            fontVariantNumeric: 'tabular-nums',
                                                                            letterSpacing: "0.01rem",
                                                                            color: Number(item.amountCcl) < 0 ? "red" : "black"
                                                                        }}
                                                                        align="right"
                                                                    >
                                                                        <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                                            <span>USD</span>
                                                                            <span>{formattNumber(item.amountCcl)}</span>
                                                                        </div>
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            )}
                                        </div>
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    </Box>

                    <Box
                        sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'space-between',
                            //gap: 2,
                            //marginTop: '1rem',
                        }}
                    >
                        <Box
                            sx={{
                                flex: '1 1 48%', // se ajusta en pantallas grandes
                                minWidth: '320px', // ancho mínimo en pantallas chicas
                                //border: 1,
                                //borderColor: "rgb(0 0 0 / 13%)",
                                borderRadius: '4px',
                                padding: "4px",
                                margin: "4px",
                                backgroundColor: "rgba(0, 0, 0, 0.02)"
                            }}
                        >
                            <Box>
                                <Box display="flex" alignItems="center">
                                    <IconButton onClick={() => handleToggleCollapseBox7()}>
                                        {collapsedStatesBox7 ? (<ExpandLessIcon />) : (<ExpandMoreIcon />)}
                                    </IconButton>
                                    <Typography
                                        fontSize={'0.75rem'}
                                        fontWeight={'600'}
                                        component="div"
                                    >
                                        Proveedores del día (No Post)
                                    </Typography>
                                </Box>
                                {collapsedStatesBox7 && (
                                    <Box sx={{ width: '100%', overflowX: 'auto' }}>
                                        <div style={{ marginTop: '4px' }}>

                                            {!loadBox7 && (
                                                <CircularProgress size={60} />
                                            )}
                                            {loadBox7 && (
                                                <TableContainer component={Paper} sx={{ maxHeight: '400px', overflowY: 'auto' }}>
                                                    <Table sx={{ minWidth: 800, height: '100%' }} aria-label="simple table">
                                                        <TableHead>
                                                            <TableRow style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: 'rgb(50 59 152)' }}>
                                                                <TableCell style={{ color: 'white' }}>Mercado</TableCell>
                                                                <TableCell style={{ color: 'white' }}>Fecha</TableCell>
                                                                <TableCell style={{ color: 'white' }}>Número</TableCell>
                                                                <TableCell style={{ color: 'white' }}>Comprobante</TableCell>
                                                                <TableCell style={{ color: 'white', textAlign: 'center', minWidth: '12ch' }}>PESOS</TableCell>
                                                                <TableCell style={{ color: 'white', textAlign: 'center', minWidth: '12ch' }}>MEP</TableCell>
                                                                <TableCell style={{ color: 'white', textAlign: 'center', minWidth: '12ch' }}>CABLE</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {viewDataBox7()}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            )}
                                        </div>
                                    </Box>
                                )}

                            </Box>


                        </Box>


                        <Box
                            sx={{
                                flex: '1 1 48%', // se ajusta en pantallas grandes
                                minWidth: '320px', // ancho mínimo en pantallas chicas
                                //border: 1,
                                //borderColor: "rgb(0 0 0 / 13%)",
                                borderRadius: '4px',
                                padding: "4px",
                                margin: "4px",
                                backgroundColor: "rgba(0, 0, 0, 0.02)"
                            }}
                        >
                            <Box>
                                <Box display="flex" alignItems="center">
                                    <IconButton onClick={() => handleToggleCollapseBox8()}>
                                        {collapsedStatesBox8 ? (<ExpandLessIcon />) : (<ExpandMoreIcon />)}
                                    </IconButton>
                                    <Typography
                                        fontSize={'0.75rem'}
                                        fontWeight={'600'}
                                        component="div"
                                    >
                                        DISPONIBILIDADES
                                    </Typography>
                                </Box>

                                {collapsedStatesBox8 && (
                                    <Box sx={{ width: '100%', overflowX: 'auto' }}>
                                        <div style={{ marginTop: '4px' }}>

                                            <div className="mi-componente-material-ui">
                                                <Grid container sx={{ m: 0.5 }} xs={12} item>
                                                    <Grid item>
                                                        <Box
                                                            display="flex"
                                                            alignItems="center"
                                                            marginLeft="20px"
                                                            flexWrap="nowrap"
                                                        >
                                                            <TriStateSwitch
                                                                value={switchBox3}
                                                                id="isSettlementToday"
                                                                name="POST"
                                                                onChange={(event) =>
                                                                    handleFieldFilterChangeSwitch3(
                                                                        event
                                                                    )
                                                                }
                                                            />
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </div>

                                            {!loadBox8 && (
                                                <CircularProgress size={60} />
                                            )}
                                            {loadBox8 && (
                                                <TableContainer
                                                    component={Paper}
                                                    sx={{
                                                        maxHeight: 400,
                                                        overflowX: 'auto',
                                                        overflowY: 'auto',
                                                        width: '100%',
                                                    }}
                                                >
                                                    <Table aria-label="simple table" sx={{ minWidth: 650 }}>
                                                        <TableHead
                                                            sx={{
                                                                position: "sticky",
                                                                top: 0,
                                                                backgroundColor: "white",
                                                                zIndex: 2
                                                            }}
                                                        >

                                                            <TableRow style={{ backgroundColor: 'rgb(50 59 152)' }}>
                                                                <TableCell style={{ color: 'white' }}>Cuenta</TableCell>
                                                                <TableCell style={{ color: 'white', textAlign: 'center' }}>PESOS</TableCell>
                                                                <TableCell style={{ color: 'white', textAlign: 'center' }}>MEP</TableCell>
                                                                <TableCell style={{ color: 'white', textAlign: 'center' }}>CABLE</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {dataBox8.map((item, index) => (
                                                                <TableRow sx={getRowStyle(false, index)} key={index}>
                                                                    <TableCell>{item.account}</TableCell>
                                                                    <TableCell
                                                                        style={{
                                                                            fontVariantNumeric: 'tabular-nums',
                                                                            letterSpacing: "0.01rem",
                                                                            color: Number(item.amountFx) < 0 ? "red" : "black"
                                                                        }}
                                                                        align="right"
                                                                    >
                                                                        <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                                            {item.amountFx && (
                                                                                <>
                                                                                    <span>$</span>
                                                                                    <span>{formattNumber(item.amountFx)}</span>
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    </TableCell>

                                                                    <TableCell
                                                                        style={{
                                                                            fontVariantNumeric: 'tabular-nums',
                                                                            letterSpacing: "0.01rem",
                                                                            color: Number(item.amountMep) < 0 ? "red" : "black"
                                                                        }}
                                                                        align="right"
                                                                    >
                                                                        <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                                            {item.amountMep && (
                                                                                <>
                                                                                    <span>USD</span>
                                                                                    <span>{formattNumber(item.amountMep)}</span>
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    </TableCell>
                                                                    <TableCell
                                                                        style={{
                                                                            fontVariantNumeric: 'tabular-nums',
                                                                            letterSpacing: "0.01rem",
                                                                            color: Number(item.amountCcl) < 0 ? "red" : "black"
                                                                        }}
                                                                        align="right"
                                                                    >
                                                                        <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                                            {item.amountCcl && (
                                                                                <>
                                                                                    <span>USD</span>
                                                                                    <span>{formattNumber(item.amountCcl)}</span>
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                            <TableRow sx={getRowStyle(true, 500)}>
                                                                <TableCell align="right">TOTAL</TableCell>
                                                                <TableCell
                                                                    style={{
                                                                        fontVariantNumeric: 'tabular-nums',
                                                                        letterSpacing: "0.01rem",
                                                                        color: Number(totalesBox8.amountFx) < 0 ? "red" : "black"
                                                                    }}
                                                                    align="right"
                                                                >
                                                                    <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                                        {totalesBox8.amountFx && (
                                                                            <>
                                                                                <span>$</span>
                                                                                <span>{formattNumber(totalesBox8.amountFx)}</span>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </TableCell>
                                                                <TableCell
                                                                    style={{
                                                                        fontVariantNumeric: 'tabular-nums',
                                                                        letterSpacing: "0.01rem",
                                                                        color: Number(totalesBox8.amountMep) < 0 ? "red" : "black"
                                                                    }}
                                                                    align="right"
                                                                >
                                                                    <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                                        {totalesBox8.amountMep && (
                                                                            <>
                                                                                <span>USD</span>
                                                                                <span>{formattNumber(totalesBox8.amountMep)}</span>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </TableCell>
                                                                <TableCell
                                                                    style={{
                                                                        fontVariantNumeric: 'tabular-nums',
                                                                        letterSpacing: "0.01rem",
                                                                        color: Number(totalesBox8.amountCcl) < 0 ? "red" : "black"
                                                                    }}
                                                                    align="right"
                                                                >
                                                                    <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                                        {totalesBox8.amountCcl && (
                                                                            <>
                                                                                <span>USD</span>
                                                                                <span>{formattNumber(totalesBox8.amountCcl)}</span>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            )}
                                        </div>
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    </Box>
                </>
            )
            }
            <FooterOperaciones />
        </div >
    )
}

export default HomeAdmin